import { BALANCE_FAIL, BALANCE_SUCCESS } from '../actionTypes';

const initialState = {
    user: null
};

const addBalanceReducer = (state = initialState, action) => {
    switch (action.type) {
        case BALANCE_SUCCESS:
            return {
                ...state,
                isLoggedIn: true,
                user: action.payload.user,
            };
        case BALANCE_FAIL:
            return {
                ...state,
                isLoggedIn: false,
                user: null,
            };
        default:
            break;
    }

    return state;
};

export default addBalanceReducer;
